/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Verdi Dashboard API
 * API for the Verdi Dashboard application
 * OpenAPI spec version: 1.0.0
 */

export type ExportDataStreamsCsvBodyDateTimeFormat =
	(typeof ExportDataStreamsCsvBodyDateTimeFormat)[keyof typeof ExportDataStreamsCsvBodyDateTimeFormat];

export const ExportDataStreamsCsvBodyDateTimeFormat = {
	SPREADSHEET_24H: "SPREADSHEET_24H",
	ISO_8601: "ISO_8601",
} as const;
